import { Box, Typography, List, ListItem } from "@mui/material";
import React from "react";
import data from "../../Assets/data/bookreviews.json";
const ReviewsSection = React.forwardRef((props, ref) => {
  return (
    <>
      <Box ref={ref}>
        <Typography
          style={{ margin: "24px 0px 0px" }}
          fontSize="32px"
          fotnWeight={800}
        >
          Book Reviews
        </Typography>
        <List>
          {data.map((review, i) => {
            return (
              <ListItem
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography fontWeight={600} fontSize="18px">
                  {review.book}
                </Typography>
                <Typography>{review.reviewer}</Typography>
                <Typography fontSize="14px">{review.year}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
});

export default ReviewsSection;
